import M from "moment/moment";
import Button from "../../../modules/commons/Button";
import React from "react";
import SimpleCheckBox from "../../../modules/SimpleCheckBox";
import * as R from "ramda";
import { defaultTableChange1 } from "../../../modules/custom/customTable";
import SimpleDDL from "../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../common/mapper";
import SimpleInput from "../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";

export const formGroupNOSCreate = {
  receivingPartId: { value: null },
  id: { value: null },
  receivingPartId: { value: null },
  shippingNo: { value: null, mandatory: true },
  numberOfSPBP: { value: null, mandatory: true },
  dateOfSPBP: { value: null, mandatory: true },
  invoiceNo: { value: null },
  receivedNo: { value: null },
  shippingDate: { value: null, mandatory: true },
  supplierId: { value: null, mandatory: true },
  carId: { value: null },
  expeditionId: { value: null },
  note: { value: null },
  partWithQR: { value: [] },
  partWithOutQR: { value: [] },
};

export const initialDataDetail = {
  partCode: null,
  partName: null,
  categoryName: null,
  quantity: null,
  purchaseOrderNo: null,
  orderType: null,
  hotlineOrderNo: null,
  locatorId: null,
  saved: false,
};

export const tableConfig = {
  nosOptionDetail: (handleOnRowSelected) => {
    return {
      ...defaultTableChange1(
        () => {},
        () => {},
        (e) => handleOnRowSelected(e),
      ),
      selectableRows: true,
      serverSide: false,
    };
  },

  nosOptionCorrection: {
    selectableRows: false,
    serverSide: false,
  },
};

export const tableColumns = (
  handleModalDetailVisibility,
  handleOnDelete,
  handleModalDetailViewVisibility,
  userAccess,
  pagination,
) => {
  return [
    {
      name: "id",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const page = pagination.page - 1;
          const limit = pagination.limit;

          const rowNumber = page * limit + tableMeta.rowIndex + 1;
          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    {
      name: "dateOfSPBP",
      label: "Tgl. SPBP",
      options: {
        sort: false,
      },
    },
    {
      name: "numberOfSPBP",
      label: "No. SPBP",
      options: {
        sort: false,
      },
    },
    {
      name: "shippingDate",
      label: "Tanggal SL",
      options: {
        sort: false,
      },
    },
    {
      name: "shippingNo",
      label: "No. SL",
      options: {
        sort: false,
      },
    },
    {
      name: "supplierName",
      label: "Nama Supplier",
      options: {
        sort: false,
      },
    },
    {
      name: "quantity",
      label: "Jumlah",
      options: {
        sort: false,
      },
    },
    {
      name: "",
      label: "Aksi",
      options: {
        customBodyRender: (_, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          return (
            <FlexView style={{ gap: "8px" }}>
              <Button
                key={`view_${rowIndex}`}
                className="btnAct"
                onClick={() =>
                  handleModalDetailViewVisibility(rowIndex, "view")
                }
                title="Lihat Detail"
              >
                <i
                  className="fa fa-lg fa-eye"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>

              <Button
                key={`edit_${rowIndex}`}
                className="btnAct"
                disabled={!userAccess.updateAccess}
                onClick={() => handleModalDetailVisibility(rowIndex, "edit")}
                title="Edit Data"
              >
                <i
                  className="fa fa-lg fa-pencil-alt"
                  style={{
                    fontSize: 20,
                    color: userAccess.updateAccess ? "red" : "grey",
                  }}
                />
              </Button>

              <Button
                key={`delete_${rowIndex}`}
                className="btnAct"
                disabled={!userAccess.deleteAccess}
                onClick={() => handleOnDelete(rowIndex)}
                title="Hapus Data"
              >
                <i
                  className="fa fa-lg fa-trash"
                  style={{
                    fontSize: 20,
                    color: userAccess.deleteAccess ? "red" : "grey",
                  }}
                />
              </Button>
            </FlexView>
          );
        },
        sort: false,
      },
    },
  ];
};

export const tableDetailColumns = {
  detail: ({ handlers, state, dataItem, mode, classes }) => {
    const columns = getColumns({ handlers, state, dataItem, mode, classes });
    return {
      QR: columns,
      NOQR: columns,
    };
  },
  detailView: ({ handlers, state, dataItem, mode }) => {
    const columns = getColumnsView({ handlers, state, dataItem, mode });
    return {
      QR: columns,
      NOQR: columns,
    };
  },
};

const getColumns = ({ handlers, state, dataItem, mode, classes }) => {
  const activeTab = state.activeTab;
  const errors = state.validationErrors?.[activeTab] || {};

  const hasHotline = state.hasHotline || false;
  const hotlineLabel = hasHotline ? (
    <span>
      No Hotline Order <span>*</span>
    </span>
  ) : (
    "No Hotline Order"
  );

  const baseColumns = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
                return <>{tableMeta.rowIndex + 1}</>;
            },
            sort: false,
        },
    },
    {
      name: "partCode",
      label: "Kode Part*",
      options: {
        customBodyRender: (value, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          const errorMsg =
            state.validationErrors?.[activeTab]?.[rowIndex]?.partCode || "";
          const val =
            value && typeof value === "object"
              ? value
              : value
                ? { label: value, value }
                : null;

          const options = (
            dataItem?.[activeTab]?.[rowIndex] ||
            state.dataPart ||
            []
          ).map((p) => ({
            label: `${p.kodePart || p.value || ""} - ${
              p.partName || p.label || ""
            }`,
            value: p.kodePart || p.value || "",
            satuan: p.satuan || "",
            partName: p.partName || p.label || "",
            partCategory: p.partCategory || "",
          }));

          return isSaved ? (
            <p>{val?.label || "-"}</p>
          ) : (
            <>
              <SimpleDDL
                id={`ddl_kodePart_${rowIndex}`}
                box="search"
                name="partCode"
                menuPosition="fixed"
                isClearable
                containerclassname="margin-bottom-5px width width-250px"
                options={options}
                value={val}
                onChange={(opt) =>
                  handlers.handleItemChange(rowIndex, "partCode", opt)
                }
              />
              {errorMsg && (
                <small
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 2,
                    display: "block",
                  }}
                >
                  {errorMsg}
                </small>
              )}
            </>
          );
        },
        setCellProps: () => ({ style: { minWidth: 180 } }),
      },
    },
    {
      name: "partName",
      label: "Nama Part*",
      options: {
        customBodyRender: (value, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          const errorMsg =
            state.validationErrors?.[activeTab]?.[rowIndex]?.partName || "";
          const val =
            value && typeof value === "object"
              ? value
              : value
                ? { label: value, value }
                : null;

          const options =
            dataItem?.[activeTab]?.[rowIndex] ||
            state.dataPart?.map((p) => ({
              label: p.partName,
              value: p.kodePart,
              satuan: p.satuan,
            })) ||
            [];

          return isSaved ? (
            <p>{val?.label || "-"}</p>
          ) : (
            <>
              <SimpleDDL
                id={`ddl_namaPart_${rowIndex}`}
                box="search"
                name="partName"
                menuPosition="fixed"
                containerclassname="margin-bottom-5px width width-250px"
                options={options}
                isClearable
                value={val}
                onChange={(opt) =>
                  handlers.handleItemChange(rowIndex, "partName", opt)
                }
              />
              {errorMsg && (
                <small
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 2,
                    display: "block",
                  }}
                >
                  {errorMsg}
                </small>
              )}
            </>
          );
        },
        setCellProps: () => ({ style: { minWidth: 220 } }),
      },
    },
    {
      name: "categoryName",
      label: "Kategori",
      options: {
        customBodyRender: (val) => <p>{val || "-"}</p>,
        setCellProps: () => ({ style: { minWidth: "150px" } }),
      },
    },
    {
      name: "quantity",
      label: "QTY*",
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          const errorMsg =
            state.validationErrors?.[activeTab]?.[rowIndex]?.quantity || "";
          return isSaved ? (
            <p>{val}</p>
          ) : (
            <>
              <SimpleInput
                id={`input_qty_${rowIndex}`}
                box="onlyNumber"
                name="quantity"
                containerclassname="margin-bottom-5px width width-250px"
                value={val}
                onChange={({ target }) =>
                  handlers.handleValueChange(
                    rowIndex,
                    target.name,
                    target.value,
                  )
                }
              />
              {errorMsg && (
                <small
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 2,
                    display: "block",
                  }}
                >
                  {errorMsg}
                </small>
              )}
            </>
          );
        },
        setCellProps: () => ({ style: { minWidth: "100px" } }),
      },
    },
    {
      name: "purchaseOrderNo",
      label: "No PO",
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          const errorMsg =
            state.validationErrors?.[activeTab]?.[rowIndex]?.purchaseOrderNo ||
            "";
          return isSaved ? (
            <p>{val || "-"}</p>
          ) : (
            <>
              <SimpleInput
                id={`input_po_${rowIndex}`}
                name="purchaseOrderNo"
                value={val}
                containerclassname="margin-bottom-5px width width-250px"
                onChange={({ target }) =>
                  handlers.handleValueChange(
                    rowIndex,
                    target.name,
                    target.value,
                  )
                }
              />
              {errorMsg && (
                <small
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 2,
                    display: "block",
                  }}
                >
                  {errorMsg}
                </small>
              )}
            </>
          );
        },
        setCellProps: () => ({ style: { minWidth: "150px" } }),
      },
    },
    {
      name: "orderType",
      label: "Jenis Order*",
      options: {
        customBodyRender: (value, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          const errorMsg =
            state.validationErrors?.[activeTab]?.[rowIndex]?.orderType || "";
          const val =
            value && typeof value === "object"
              ? value
              : value
                ? { label: value, value }
                : null;

          const row = state.dataTable?.[activeTab]?.[rowIndex] || {};
          const isExistingData = row.isNew === false || (!row.isNew && row.id);
          const isReadOnly =
            mode === "edit" && activeTab === "NOQR" && isExistingData;

          return isSaved ? (
            <p>{val?.label || val?.value || "-"}</p>
          ) : (
            <>
              <SimpleDDL
                id={`ddl_jenisOrder_${rowIndex}`}
                box="search"
                value={val}
                readOnly={isReadOnly}
                menuPosition="fixed"
                containerclassname={`margin-bottom-5px width width-250px ${
                  isReadOnly ? "opacity-70 cursor-not-allowed" : ""
                }`}
                onChange={(val) =>
                  handlers.handleOrderTypeChange(rowIndex, val)
                }
                options={
                  state.dataOrderType?.map((item) => ({
                    label: item.label,
                    value: item.value,
                  })) ?? []
                }
                isClearable
              />
              {errorMsg && (
                <small
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 2,
                    display: "block",
                  }}
                >
                  {errorMsg}
                </small>
              )}
            </>
          );
        },
        setCellProps: () => ({ style: { minWidth: "250px" } }),
      },
    },
    {
      name: "hotlineOrderNo",
      label: hotlineLabel,
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          const errorMsg =
            state.validationErrors?.[activeTab]?.[rowIndex]?.hotlineOrderNo ||
            "";

          return isSaved ? (
            <p>{val || "-"}</p>
          ) : (
            <>
              <FlexView vAlignContent="center">
                <SimpleInput
                  id={`input_hotline_${rowIndex}`}
                  name="hotlineOrderNo"
                  containerclassname="margin-bottom-5px width width-250px"
                  readOnly={!hasHotline}
                  value={val}
                  onChange={({ target }) =>
                    handlers.handleValueChange(
                      rowIndex,
                      target.name,
                      target.value,
                    )
                  }
                />
                <SimpleButton
                  disabled={hasHotline}
                  className={!hasHotline ? classes.forceGray : ""}
                  styles={{ width: "auto", height: 38 }}
                  text="..."
                  onClick={handlers.handleDetailHotlineVisible}
                />
              </FlexView>

              {errorMsg && (
                <small
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 2,
                    display: "block",
                  }}
                >
                  {errorMsg}
                </small>
              )}
            </>
          );
        },
        setCellProps: () => ({ style: { minWidth: "250px" } }),
      },
    },
    {
      name: "locatorId",
      label: "Locator*",
      options: {
        customBodyRender: (value, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          const errorMsg =
            state.validationErrors?.[activeTab]?.[rowIndex]?.locatorId || "";
          const val =
            value && typeof value === "object"
              ? value
              : value
                ? { label: value, value }
                : null;

          return isSaved ? (
            <p>{val?.label || "-"}</p>
          ) : (
            <>
              <SimpleDDL
                id={`ddl_locator_${rowIndex}`}
                box="search"
                value={val}
                menuPosition="fixed"
                containerclassname="margin-bottom-5px width width-250px"
                onChange={(val) =>
                  handlers.handleSingleLocatorChange(rowIndex, val)
                }
                options={
                  state.dataLocator?.map((item) =>
                    mapToObjectDDL(item.nameLocation, item.kodeLocation),
                  ) ?? []
                }
                isClearable
              />
              {errorMsg && (
                <small
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 2,
                    display: "block",
                  }}
                >
                  {errorMsg}
                </small>
              )}
            </>
          );
        },
        setCellProps: () => ({ style: { minWidth: "250px" } }),
      },
    },
  ];

  const actionColumn = {
    name: "saved",
    label: "Aksi",
    options: {
      customBodyRender: (val, { rowIndex }) => (
        <FlexView style={{ gap: "2px" }}>
          {!val ? (
            <SimpleButton
              className="btn background-red"
              styles={{ width: "unset" }}
              onClick={() => handlers.handleSaveRow(rowIndex)}
              icon={<i className="fa fa-save" />}
            />
          ) : (
            <SimpleButton
              className="btn background-red"
              styles={{ width: "unset" }}
              onClick={() => handlers.handleEditRow(rowIndex)}
              icon={<i className="fa fa-pencil-alt" />}
            />
          )}
          <SimpleButton
            className="btn background-red"
            styles={{ width: "unset" }}
            onClick={() => handlers.handleDeleteRow(rowIndex)}
            icon={<i className="fa fa-trash" />}
          />
        </FlexView>
      ),
      sort: false,
    },
  };

  const currentMode = mode || state.mode;

  if (currentMode !== "view") {
    const hasAction = baseColumns.some((col) => col.label === "Aksi");
    if (!hasAction) baseColumns.push(actionColumn);
  }

  return baseColumns;
};

const getColumnsView = ({ handlers, state, dataItem, mode }) => {
  const activeTab = state.activeTab;
  const hasHotline = state.hasHotline || false;

  const hotlineLabel = hasHotline ? (
    <span>
      No Hotline Order <span>*</span>
    </span>
  ) : (
    "No Hotline Order"
  );

  return [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
                return <>{tableMeta.rowIndex + 1}</>;
            },
            sort: false,
        },
    },
    {
      name: "partCode",
      label: "Kode Part",
      options: {
        customBodyRender: (value) => {
          const val =
            value && typeof value === "object"
              ? value?.label || value?.value
              : value || "-";
          return <p>{val}</p>;
        },
        setCellProps: () => ({ style: { minWidth: 180 } }),
      },
    },
    {
      name: "partName",
      label: "Nama Part",
      options: {
        customBodyRender: (value) => {
          const val =
            value && typeof value === "object"
              ? value?.label || value?.value
              : value || "-";
          return <p>{val}</p>;
        },
        setCellProps: () => ({ style: { minWidth: 220 } }),
      },
    },
    {
      name: "categoryName",
      label: "Kategori",
      options: {
        customBodyRender: (val) => <p>{val || "-"}</p>,
        setCellProps: () => ({ style: { minWidth: "150px" } }),
      },
    },
    {
      name: "barcode",
      label: "QR Code",
      options: {
        customBodyRender: (val) => <p>{val?.partBarcode || "-"}</p>,
        setCellProps: () => ({ style: { minWidth: "100px" } }),
      },
    },
    {
      name: "purchaseOrderNo",
      label: "No PO",
      options: {
        customBodyRender: (val) => <p>{val || "-"}</p>,
        setCellProps: () => ({ style: { minWidth: "150px" } }),
      },
    },
    {
      name: "orderType",
      label: "Jenis Order",
      options: {
        customBodyRender: (value) => {
          const label =
            value && typeof value === "object"
              ? value?.label || value?.value
              : value || "-";
          return <p>{label}</p>;
        },
        setCellProps: () => ({ style: { minWidth: "250px" } }),
      },
    },
    {
      name: "hotlineOrderNo",
      label: hotlineLabel,
      options: {
        customBodyRender: (val) => <p>{val || "-"}</p>,
        setCellProps: () => ({ style: { minWidth: "250px" } }),
      },
    },
    {
      name: "locatorId",
      label: "Locator",
      options: {
        customBodyRender: (value) => {
          const label =
            value && typeof value === "object"
              ? value?.label || value?.value
              : value || "-";
          return <p>{label}</p>;
        },
        setCellProps: () => ({ style: { minWidth: "250px" } }),
      },
    },
  ];
};

export const tableColumnsHO = () => [
  {
    name: "hoDate",
    label: "Tanggal HO",
    options: { sort: false },
  },
  {
    name: "noHo",
    label: "No. Hotline Order",
    options: { sort: false },
  },
  {
    name: "konsumen",
    label: "Nama Konsumen",
    options: { sort: false },
  },
];

export const tableColumnsDetail = () => [
  {
    name: "kodePart",
    label: "Kode Part",
    options: { sort: false },
  },
  {
    name: "namaPart",
    label: "Nama Part",
    options: { sort: false },
  },
  {
    name: "status",
    label: "Status",
    options: { sort: false },
  },
];
